module.exports = __webpack_public_path__ + "static/media/device_bg.a226b0c7.png";